import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class PatrolBoatBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.PATROL_BOAT;
}

export default PatrolBoatBuildingTileEntity;
